import 'twin.macro';
import { TrashIcon } from '@heroicons/react/20/solid';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import DeleteAccountModal from '@teetsh/app/src/containers/UserSettings/Compte/DeleteAccount/DeleteAccountModal';
import React, { useState } from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';

export function DeleteAccount() {
  const { t } = useTranslation(['userSettings', 'common']);
  const [isDeleteAccountOpen, setDeleteAccountOpen] = useState<boolean>(false);
  return (
    <>
      <DeleteAccountModal
        isOpen={isDeleteAccountOpen}
        onClose={() => setDeleteAccountOpen(false)}
      />
      <TwoColumnsCardSidebar.Section
        title={
          <span tw="text-danger">{t('userSettings:account.dangerZone')}</span>
        }
      >
        <Button
          intent="danger"
          onClick={() => setDeleteAccountOpen(true)}
          icon={TrashIcon}
        >
          {t('userSettings:account.deleteAccountLabel')}
        </Button>
      </TwoColumnsCardSidebar.Section>
    </>
  );
}
